import { render, staticRenderFns } from "./AboutStars.vue?vue&type=template&id=48298420"
import script from "./AboutStars.vue?vue&type=script&lang=js"
export * from "./AboutStars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports